/**
 * Satisfaction Rating Constants
 */

export interface SatisfactionLevel {
  value: number;
  label: string;
  emoji: string;
}

export const SATISFACTION_LEVELS: readonly SatisfactionLevel[] = [
  { value: 1, label: 'Meh', emoji: '😕' },
  { value: 2, label: 'Okay', emoji: '😐' },
  { value: 3, label: 'Good', emoji: '🙂' },
  { value: 4, label: 'Great', emoji: '😊' },
  { value: 5, label: 'Amazing', emoji: '🎉' },
] as const;

export const MIN_SATISFACTION = 1;
export const MAX_SATISFACTION = 5;
